<template>
  <Loader v-if="loader" />

  <prime-accordion class="box-operation-detail">
    <prime-accordion-tab>
      <template #header>
        <i class="pi pi-plus-circle"> </i>
        <span class="pl-1">Operazioni</span>
      </template>
      <div v-if="data.item.id">
        <span>
          <prime-button
            label="VOLTURA"
            icon="pi pi-directions"
            iconPos="right"
            class="p-button-secondary mr-3"
            @click="onVoltura($event)"
          />
        </span>

        <span>
          <prime-button
            label="CAMBIA OFFERTA"
            icon="pi pi-directions"
            iconPos="right"
            class="p-button-secondary mr-3"
            @click="onCambiaOfferta($event)"
          />
        </span>

        <span>
          <prime-button
            label="AGGIUNGI VOCE FATTURA"
            icon="pi pi-directions"
            iconPos="right"
            class="p-button-secondary mr-3"
            @click="openFatturaVociDialog($event)"
          />
        </span>
      </div>
    </prime-accordion-tab>
  </prime-accordion>

  <SupplyRiepilogoSection
    v-if="data.item.id"
    :contratti-vendita="data.item.contratti?.vendita || []"
    :fatture="data.item.fatture || {}"
    :pratiche-data="praticheData"
    :supply-points="[{ id: data.item.id, type: 'pdr', code: data.item.info?.code }]"
    forniture-label="Fornitura associata"
  />

  <prime-accordion
    :multiple="true"
    :activeIndex="[0]"
    @tab-open="onDetailAccordionTabOpen"
  >
    <prime-accordion-tab>
      <template v-if="data.item.id" #header>
        <span>Anagrafica Pdr</span>&nbsp;<span>{{ data.item.info.code }}</span>
      </template>

      <div v-if="data.item.id">
        <div class="formgrid grid">
          <div class="field col-12">
            <h4>{{ data.item.info.code }}</h4>
          </div>
          <div class="field col-12 md:col-4">
            <label for="data_fine">Data Inizio</label>
            <prime-calendar
              id="data_inizio"
              v-model="dataInizio"
              :showIcon="true"
              dateFormat="dd/mm/yy"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="remi">Remi</label>
            <prime-input-text
              id="remi"
              v-model="data.item.info.remi"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="consumo_annuo">Consumo Annuo</label>
            <prime-input-number
              id="consumo_annuo"
              v-model="data.item.info.consumo_annuo"
              mode="decimal"
              locale="it-IT"
              :minFractionDigits="2"
              :maxFractionDigits="2"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="data_fine">Data Fine</label>
            <prime-calendar
              id="data_fine"
              v-model="dataFine"
              :showIcon="true"
              dateFormat="dd/mm/yy"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="classe">Classe</label>
            <prime-input-text
              id="classe"
              v-model="data.item.info.classe"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="fatturazione_solo_reale">Fatturazione solo reale</label>
            <prime-dropdown
              id="fatturazione_solo_reale"
              v-model="data.item.info.fatturazione_solo_reale"
              :options="data.booleanSelect"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleziona..."
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="disalimentabile">Disalimentabile</label>
            <prime-dropdown
              id="disalimentabile"
              v-model="data.item.info.disalimentabile"
              :options="data.disalimentabiliBoolean"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleziona..."
              :disabled="true"
              class="inputfield w-full"
            />
          </div>
          <!-- <div class="field col-12 md:col-4">
            <label for="disalimentabile">Disalimentabile</label>
            <prime-input-text 
              id="disalimentabile" 
              v-model="data.item.info.disalimentabile" 
              type="text" 
              :disabled="true"
              class="inputfield w-full"
            />
          </div> -->
          <div class="field col-12 md:col-4">
            <label for="toponimo">Toponimo</label>
            <prime-input-text
              id="toponimo"
              v-model="data.item.info.toponimo"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="matricola">Matricola Contatore</label>
            <prime-input-text
              id="matricola"
              v-model="data.item.info.matricola"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="indirizzo">Indirizzo</label>
            <prime-input-text
              id="indirizzo"
              v-model="data.item.info.indirizzo"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_uso">Tipologia Residente</label>
            <prime-dropdown
              id="cod_type_uso"
              v-model="data.item.info.cod_type_uso"
              :options="data.tipiUso"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona..."
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="civico">Numero Civico</label>
            <prime-input-text
              id="civico"
              v-model="data.item.info.civico"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="cap">CAP</label>
            <prime-input-text
              id="cap"
              v-model="data.item.info.cap"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="cod_comune">Comune</label>
            <prime-dropdown
              id="cod_comune"
              v-model="data.item.info.cod_comune"
              :options="data.comuni"
              optionLabel="name"
              optionValue="id"
              dataKey="id"
              placeholder="Seleziona..."
              :filter="true"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="cig">CIG</label>
            <prime-input-text
              id="cig"
              v-model="data.item.info.CIG"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="cup">CUP</label>
            <prime-input-text
              id="cup"
              v-model="data.item.info.CUP"
              type="text"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="cod_comune">Accisa</label>
            <prime-dropdown
              id="cod_type_accisa"
              v-model="data.item.info.cod_type_accisa"
              :options="data.tipiAccisa"
              optionLabel="name"
              optionValue="id"
              dataKey="id"
              placeholder="Seleziona..."
              :filter="true"
              :disabled="!isInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4 flex align-items-center">
            <label class="mr-2">Sospendibile</label>
            <Checkbox :binary="true" v-model="data.item.info.sospendibile" :disabled="!isInEdit"/>
          </div>
        </div>

        <div class="grid p-jc-end">
          <div class="col-12 text-right" v-if="!isInEdit">
            <prime-button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success mr-2"
              @click="onEditInfo"
            />
          </div>

          <div class="col-12 text-right" v-if="isInEdit">
            <prime-button
              icon="pi pi-times"
              class="p-button-rounded p-button-danger mr-2"
              @click="onAbortInfoEdit"
            />
            <prime-button
              icon="pi pi-check"
              class="p-button-rounded p-button-success mr-2"
              @click="onUpdateInfo"
            />
          </div>
        </div>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab
      v-if="hasWizardCaricamentiAccess"
      header="Caricamenti Wizard"
    >
      <div v-if="data.item.id">
        <Loader v-if="wizardCaricamentiLoading" />
        <div
          v-else-if="wizardCaricamenti.length === 0"
          class="p-3 text-600"
        >
          Nessun caricamento wizard trovato
        </div>
        <prime-data-table
          v-else
          :value="wizardCaricamenti"
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          responsiveLayout="scroll"
          showGridlines
          scrollable
        >
          <prime-column
            v-for="column of wizardCaricamentiColumns"
            :key="column"
            :field="column"
            :header="column"
            style="min-width: 180px"
          >
            <template #body="{ data: rowData }">
              <prime-button
                v-if="column === 'logs_modifiche' && hasWizardCaricamentiLogs(rowData[column])"
                label="Vedi log"
                icon="pi pi-list"
                class="p-button-sm p-button-text"
                @click="openWizardCaricamentiLogsDialog(rowData)"
              />
              <prime-button
                v-else-if="column === 'matrice_id' && rowData[column]"
                :label="String(rowData[column])"
                icon="pi pi-search"
                class="p-button-sm p-button-text"
                @click="openWizardCaricamentoMatriceDialog(rowData[column])"
              />
              <span v-else-if="column === 'logs_modifiche'"></span>
              <span v-else>
                {{ formatWizardCaricamentiValue(rowData[column]) }}
              </span>
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Storico RCU">
      <div v-if="data.item.id">
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.rcus"
          responsiveLayout="scroll"
          editMode="cell"
          @cell-edit-complete="onCellRcusDateEditComplete"
        >
          <prime-column field="udd" header="UDD"></prime-column>
          <prime-column field="cc" header="CC"></prime-column>
          <prime-column
            field="data_inizio"
            header="Data Inizio"
            :sortable="true"
          >
            <template #body="{ data }">
              <p class="text-primary cursor-pointer">
                {{
                  data.data_inizio !== null
                    ? moment(data.data_inizio).format("DD/MM/YYYY")
                    : ""
                }}
              </p>
            </template>
            <template #editor="{ data, field }">
              <Calendar v-model="data[field]" dateFormat="dd/mm/yy" />
            </template>
          </prime-column>
          <prime-column field="data_fine" header="Data Fine" :sortable="true">
            <template #body="{ data }">
              <p class="text-primary cursor-pointer">
                {{
                  data.data_fine !== null
                    ? moment(data.data_fine).format("DD/MM/YYYY")
                    : ""
                }}
              </p>
            </template>
            <template #editor="{ data, field }">
              <Calendar v-model="data[field]" dateFormat="dd/mm/yy" />
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="RCU Nuovo Gas">
      <div v-if="data.item.id">
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.rcus_gas"
          responsiveLayout="scroll"
        >
          <prime-column field="Codice_pdr" header="PDR"></prime-column>
          <prime-column field="Data_inizio_for" header="Data Inizio Fornitura" :sortable="true">
            <template #body="{ data }">
              {{ data.Data_inizio_for ? moment(data.Data_inizio_for).format('DD/MM/YYYY') : '' }}
            </template>
          </prime-column>
          <prime-column field="Data_fine_for" header="Data Fine Fornitura" :sortable="true">
            <template #body="{ data }">
              {{ data.Data_fine_for ? moment(data.Data_fine_for).format('DD/MM/YYYY') : '' }}
            </template>
          </prime-column>
          <prime-column field="matricola" header="Matricola"></prime-column>
          <prime-column field="Cod_remi" header="REMI"></prime-column>
          <prime-column field="Disalimentabilita" header="Disalimentabilità"></prime-column>
          <prime-column field="Classe_gruppo_mis" header="Gruppo MIS"></prime-column>
          <prime-column field="Telegestione" header="Telegestione"></prime-column>
          <prime-column field="Prel_annuo_prev" header="Prelievo Annuo"></prime-column>
          <prime-column field="Cod_prof_prel_std" header="Profilo Prelievo"></prime-column>
          <prime-column field="Cat_uso" header="Categoria Uso"></prime-column>
          <prime-column field="Classe_prelievo" header="Classe Prelievo"></prime-column>
          <prime-column field="Ragione_sociale_udd" header="UDD"></prime-column>
          <prime-column field="Ragione_sociale_dd" header="Distributore"></prime-column>
          <prime-column field="Mese" header="Mese" :sortable="true">
            <template #body="{ data }">
              {{ data.Mese ? moment(data.Mese).format('MM/YYYY') : '' }}
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Contratti Acquisto">
      <div v-if="data.item.id">
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.contratti.acquisto"
          responsiveLayout="scroll"
        >
          <prime-column header="Contratto">
            <template #body="{ data }">
              <router-link
                :to="`/ask/contratti/acquisto/${data.id}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="`${data.code}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
            </template>
          </prime-column>
          <prime-column field="ragsoc" header="Fornitore"></prime-column>
          <prime-column header="Data Inizio">
            <template #body="{ data }">
              {{
                data.data_iniziale !== null
                  ? moment(data.data_iniziale).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>
          <prime-column field="data_fine" header="Data Fine">
            <template #body="{ data }">
              {{
                data.data_finale !== null
                  ? moment(data.data_finale).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Contratti Vendita">
      <div v-if="data.item.id">
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.contratti.vendita"
          responsiveLayout="scroll"
          editMode="cell"
          @cell-edit-init="onCellContrattoVenditaEditInit"
        >
          <prime-column header="Contratto">
            <template #body="{ data }">
              <router-link
                :to="`/ask/contratti/vendita/${data.c_id}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="`${data.code}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
            </template>
          </prime-column>
          <prime-column header="Cliente">
            <template #body="{ data }">
              <router-link
                :to="`/ask/clienti/${data.cod_cliente}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="`${data.cliente}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
            </template>
          </prime-column>
          <prime-column header="Reseller">
            <template #body="{ data }">
              <router-link
                :to="`/ask/offerte/listini/${data.cod_reseller}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="`${data.reseller}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
            </template>
          </prime-column>
          <prime-column header="Offerta">
            <template #body="{ data }">
              <router-link
                :to="`/ask/offerte/listini/${data.cod_offerta}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="`${data.offerta}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
            </template>
          </prime-column>
          <prime-column header="Data Inizio">
            <template #body="{ data }">
              {{
                data.data_iniziale !== null
                  ? moment(data.data_inizio).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>
          <prime-column field="data_fine" header="Data Fine">
            <template #body="{ data }">
              <p
                v-if="isContrattoVenditaDataFineEditable(data)"
                class="text-primary cursor-pointer m-0"
              >
                {{ formatContrattoVenditaDataFine(data) }}
              </p>
              <span v-else>{{ formatContrattoVenditaDataFine(data) }}</span>
            </template>
            <template #editor="{ data, editorCancelCallback }">
              <div
                v-if="isContrattoVenditaDataFineEditable(data)"
                class="flex align-items-center gap-2"
                @click.stop
              >
                <prime-calendar
                  v-model="data._editDataFine"
                  dateFormat="dd/mm/yy"
                  :showIcon="true"
                  appendTo="body"
                />
                <prime-button
                  icon="pi pi-check"
                  class="p-button-rounded p-button-success"
                  @click="confirmContrattoVenditaDataFine(data, editorCancelCallback)"
                />
                <prime-button
                  icon="pi pi-times"
                  class="p-button-rounded p-button-text"
                  @click="editorCancelCallback"
                />
              </div>
              <span v-else>{{ formatContrattoVenditaDataFine(data) }}</span>
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Pratiche">
      <SupplyPraticheSection
        v-if="data.item.id"
        :pratiche-data="praticheData"
        :auto-fetch="false"
        :link-fornitori="true"
        :has-stato-column="true"
      />
    </prime-accordion-tab>

    <prime-accordion-tab header="Letture">
      <div>
        <Button
          label="Crea Lettura"
          icon="pi pi-plus"
          class="p-button-success"
          @click="router.replace({ 
            path: '/AutoLettura', 
            query: { 
              pdr: data.item.info.code, 
              cod_pdr: data.item.id, 
              create: 'true',
              ultima_lettura: JSON.stringify({ consumo: data.item.letture[0]?.consumo || 0, coeff: data.item.letture[0]?.coeff || 0 })
            } 
          })"
        />

        <Button
          label="Vedi tutte le letture"
          icon="pi pi-eye"
          iconPos="right"
          class="mb-2 ml-2"
          @click="viewAllLetture"
        />

        <prime-data-table
          dataKey="id"
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.letture"
          responsiveLayout="scroll"
          editMode="row"
          @row-edit-save="onRowEditLetturaComplete"
          v-model:editingRows="editingRowsLetture"
        >
          <prime-column field="data" header="Periodo">
            <template #body="{ data }">
              <!-- {{ (data.data_misura !== null)? moment(data.data_misura).locale('it').format('MMMM YYYY').toUpperCase(): '' }} -->
              {{
                data.data_misura !== null
                  ? moment(data.data_misura).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>
          <prime-column field="consumo" header="Consumo">
            <template #editor="{ data }">
              <InputText v-model="data.consumo" />
            </template>
            <template #body="{ data }">
              <!-- {{ floatFixed2DigitFormatter.format( (data.consumo !== null)? data.consumo : 0 ) }} -->
              {{ data.consumo !== null ? data.consumo : 0 }}
            </template>
          </prime-column>
          <prime-column field="coeff" header="Coefficente">
            <template #editor="{ data }">
              <InputText v-model="data.coeff" />
            </template>
          </prime-column>
          <prime-column header="Usato" style="text-align: center">
            <template #body="{ data }">
              <i v-if="data.used" class="pi pi-check" />
              <i v-else class="pi pi-times" />
            </template>
          </prime-column>
          <prime-column header="Data Comunicazione">
            <template #body="{ data }">
              {{ data.data_comunicazione !== null
                  ? moment(data.data_comunicazione).format("DD/MM/YYYY")
                  : "" }}
            </template>
          </prime-column>
          <prime-column header="Raccolta">
            <template #body="{ data }">
              {{ data.type }}
            </template>
          </prime-column>
          <prime-column header="Tipo lettura">
            <template #body="{ data }">
              {{ data.tipolettura }}
            </template>
          </prime-column>
          <prime-column header="Autolettura">
            <template #body="{ data }">
              {{ data.autolettura ? "SI" : "NO" }}
            </template>
          </prime-column>
          <prime-column header="" style="text-align: center">
            <template #body="{ data: lettura }">
              <prime-button
                v-show="lettura.file"
                title="Download"
                icon="pi pi-download"
                iconPos="right"
                class="p-button-warning m-1"
                @click="downloadLettura(lettura)"
              />
              <prime-button
                v-show="lettura.used"
                title="Riusa"
                icon="pi pi-directions-alt"
                iconPos="right"
                class="p-button-info m-1"
                @click="riusaLettura(lettura)"
              />
              <prime-button
                v-show="lettura.autolettura"
                title="Elimina"
                icon="pi pi-trash"
                iconPos="right"
                class="p-button-danger m-1"
                @click="eliminaLettura(lettura)"
              />
            </template>
          </prime-column>
          <prime-column
            :rowEditor="true"
            style="width: 10%; min-width: 8rem"
            bodyStyle="text-align:center"
          >
            <template #body="{ data }">
              <prime-button
                v-if="data.used === 0 && data.autolettura === 1"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success"
                @click="onRowEditInit(data)"
              />
            </template>
            <template #editor="{ data }">
              <div class="flex justify-content-center">
                <prime-button
                  icon="pi pi-check"
                  class="p-button-rounded p-button-success mr-2"
                  @click="onRowEditLetturaComplete({ data, newData: data })"
                />
                <prime-button
                  icon="pi pi-times"
                  class="p-button-rounded p-button-danger"
                  @click="onRowEditCancel"
                />
              </div>
            </template>
          </prime-column>
          <prime-column
            header="Storico"
            :exportable="false"
            style="width: 4rem; text-align: center"
            bodyStyle="text-align:center"
          >
            <template #body="{ data: lettura }">
              <prime-button
                v-if="hasAutoletturaId(lettura)"
                title="Storico autolettura"
                icon="pi pi-clock"
                class="p-button-rounded p-button-help"
                @click.stop="openStoricoAutoletturaDialog(lettura)"
              />
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Altre Voci in Fattura">
      <div v-if="data.item.id">
        <Button
          label="Aggiungi Voce"
          icon="pi pi-plus"
          iconPos="right"
          class="mb-2"
          @click="openFatturaVociDialog"
        />

        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.fatture.altre_voci"
          responsiveLayout="scroll"
        >
          <prime-column field="f_desc" header="Descrizione"></prime-column>
          <prime-column field="descrizione" header="Note"></prime-column>
          <prime-column header="Data">
            <template #body="{ data }">
              {{
                data.mese !== null ? moment(data.mese).format("DD/MM/YYYY") : ""
              }}
            </template>
          </prime-column>
          <prime-column header="Importo">
            <template #body="{ data }">
              {{
                currencyFormatter.format(
                  data.importo !== null ? data.importo : 0
                )
              }}
            </template>
          </prime-column>
          <prime-column header="Aliquota">
            <template #body="{ data }">
              {{ data.aliquota !== null ? `${data.aliquota}%` : "0%" }}
            </template>
          </prime-column>
          <prime-column header="Usato" style="text-align: center">
            <template #body="{ data }">
              <i v-if="data.used" class="pi pi-check" />
              <i v-else class="pi pi-times" />
            </template>
          </prime-column>
          <prime-column style="text-align: center">
            <template #body="{ data }">
              <prime-button
                v-if="!data.used"
                icon="pi pi-trash"
                class="p-button-rounded p-button-danger m-2"
                @click="onDeleteFatturaVoce(data)"
              />
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Mensilit&agrave; reali">
      <div v-if="data.item.id">
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.mesilita_reali"
          responsiveLayout="scroll"
        >
          <prime-column field="data_insert" header="Data Creazione">
            <template #body="{ data }">
              {{
                data.data_insert !== null
                  ? moment(data.data_insert).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>

          <prime-column field="data" header="Data Comunicazione">
            <template #body="{ data }">
              {{
                data.data !== null ? moment(data.data).format("DD/MM/YYYY") : ""
              }}
            </template>
          </prime-column>

          <prime-column header="Consumo">
            <template #body="{ data }">
              {{
                floatFixed2DigitFormatter.format(
                  data.consumo !== null ? data.consumo : 0
                )
              }}
            </template>
          </prime-column>
          <prime-column header="Coefficente">
            <template #body="{ data }">
              {{
                floatFixed8DigitFormatter.format(
                  data.coeff !== null ? data.coeff : 0
                )
              }}
            </template>
          </prime-column>

          <prime-column header="Usato" style="text-align: center">
            <template #body="{ data }">
              <i v-if="data.used" class="pi pi-check" />
              <i v-else class="pi pi-times" />
            </template>
          </prime-column>
          <prime-column field="used_ft" header="Fattura"></prime-column>
          <prime-column style="text-align: center">
            <template #body="{ data }">
             <!-- <prime-button
                v-if="!data.used"
                icon="pi pi-trash"
                class="p-button-rounded p-button-danger"
                @click="onDeleteMensilitaRealeGas(this.route.params.id, data.id)"
              /> -->
              <Button
                v-if="!data.used"
                icon="pi pi-exclamation-circle"
                class="p-button-rounded p-button-warning ml-2"
                @click="onMensilitaRealeUsed2Gas(this.route.params.id, data.id)"
                v-tooltip.top="'Marca come Used 2'"
              />
              <Button
                v-if="canRiusaMensilitaReale(data)"
                icon="pi pi-replay"
                class="p-button-rounded p-button-info ml-2"
                :disabled="isRiusaMensilitaRealeDisabled(data)"
                @click="onRiusaMensilitaRealeGas(this.route.params.id, data.id)"
                v-tooltip.top="'Riusa'"
              />
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Consumi Distributore">
      <div v-if="data.item.id">
        <prime-button
          label="AGGIUNGI CONSUMO"
          icon="pi pi-plus"
          class="p-button-secondary mb-3"
          @click="openConsumoGasDialog"
        />

        <prime-data-table
          dataKey="id"
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="consumiDistributore"
          responsiveLayout="scroll"
          editMode="row"
          @row-edit-init="onRowEditInitConsumo"
          @row-edit-cancel="onRowEditCancelConsumo"
          @row-edit-save="onRowEditConsumoComplete"
          v-model:editingRows="editingRowsConsumi"
        >
          <prime-column field="data_misura" header="Data Misura"></prime-column>

          <prime-column field="consumo" header="Consumo">
            <template #editor="{ data, field }">
              <PrimeInputText v-model="data[field]" />
            </template>
          </prime-column>

          <prime-column field="coeff" header="Coefficente">
            <template #editor="{ data, field }">
              <PrimeInputText v-model="data[field]" />
            </template>
          </prime-column>

          <prime-column header="Autolettura">
            <template #body="{ data }">
              {{ data.autolettura ? "SI" : "NO" }}
            </template>
          </prime-column>

          <prime-column header="Usato">
            <template #body="{ data }">
              {{ data.used ? "SI" : "NO" }}
            </template>
          </prime-column>

          <prime-column style="width: 10%; min-width: 8rem">
            <template #body="{ data }">
              <prime-button
                icon="pi pi-trash"
                class="p-button-rounded p-button-danger p-mr-2"
                @click="onDeleteConsumoGas(data.id)"
              />
              <prime-row-editor />
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Mensilit&agrave; Fatturabile">
      <div v-if="data.item.id">
        <p class="mensilita-edit-hint">
          <i class="pi pi-pencil"></i>
          Clicca su <strong>Data inizio</strong> o <strong>Data fine</strong> per modificarle.
        </p>
        <prime-data-table
          :key="mensilitaFatturabiliKey"
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.mensilita_fatturabili"
          dataKey="id"
          responsiveLayout="scroll"
          editMode="cell"
          @cell-edit-init="onMensilitaFatturabileCellEditInit"
        >
          <prime-column header="Mese">
            <template #body="{ data }">
              {{
                data.mese !== null
                  ? moment(data.mese)
                      .locale("it")
                      .format("MMMM YYYY")
                      .toUpperCase()
                  : ""
              }}
            </template>
          </prime-column>
          <prime-column field="ragsoc" header="CC"></prime-column>
          <prime-column field="inizio" header="Data Inizio" sortable>
            <template #editor="slotProps">
              <div class="p-d-flex p-ai-center">
                <Calendar
                  v-model="slotProps.data.inizio"
                  dateFormat="yy-mm-dd"
                  showIcon
                  :minDate="getFirstDayOfMonth(slotProps.data.inizio)"
                  :maxDate="getLastDayOfMonth(slotProps.data.inizio)"
                  @date-select="onDateSelect($event, slotProps.data, 'inizio')"
                />
                <Button
                  icon="pi pi-check"
                  class="p-button-rounded p-button-success p-ml-2"
                  @click="confirmEdit(slotProps.data, 'inizio', slotProps.editorCancelCallback)"
                />
              </div>
            </template>
            <template #body="slotProps">
              <span class="editable-date-cell" title="Clicca per modificare">
                {{ formatDate(slotProps.data.inizio) }}
                <i class="pi pi-pencil"></i>
              </span>
            </template>
          </prime-column>
          <prime-column field="fine" header="Data Fine" sortable>
            <template #editor="slotProps">
              <div class="p-d-flex p-ai-center">
                <Calendar
                  v-model="slotProps.data.fine"
                  dateFormat="yy-mm-dd"
                  showIcon
                  :minDate="getFirstDayOfMonth(slotProps.data.fine)"
                  :maxDate="getLastDayOfMonth(slotProps.data.fine)"
                  @date-select="onDateSelect($event, slotProps.data, 'fine')"
                />
                <Button
                  icon="pi pi-check"
                  class="p-button-rounded p-button-success p-ml-2"
                  @click="confirmEdit(slotProps.data, 'fine', slotProps.editorCancelCallback)"
                />
              </div>
            </template>
            <template #body="slotProps">
              <span class="editable-date-cell" title="Clicca per modificare">
                {{ formatDate(slotProps.data.fine) }}
                <i class="pi pi-pencil"></i>
              </span>
            </template>
          </prime-column>
          <prime-column header="Richiesta Conguaglio" style="min-width: 170px">
            <template #body="{ data }">
              <div class="p-d-flex p-ai-center">
                <RadioButton
                  :inputId="'rapid-check-pdr-' + data.id"
                  :name="'rapid-check-pdr-' + data.id"
                  :modelValue="isRapidChecked(data) ? 1 : 0"
                  :value="1"
                  :disabled="isRapidChecked(data) || rapidCheckLoadingId === data.id"
                  @click.stop="onRapidCheck(data)"
                />
                <small v-if="isRapidChecked(data) && data.data_rapidCheck" class="p-ml-2">
                  {{ formatRapidCheckDate(data.data_rapidCheck) }}
                </small>
              </div>
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab>
      <template v-if="data.item.id" #header>
        <span>Fatture</span>&nbsp;<span
          >Totale:&nbsp;{{
            currencyFormatter.format(data.item.fatture.importo_totale)
          }}&nbsp;Da pagare:&nbsp;{{
            currencyFormatter.format(
              data.item.fatture.importo_totale -
                data.item.fatture.importo_pagato
            )
          }}</span
        >
      </template>

      <div v-if="data.item.id">
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="fatture_ordinate"
          :rowClass="fatturaRowClass"
          responsiveLayout="scroll"
        >
          <prime-column header="Numero">
            <template #body="{ data }">
              <router-link
                :to="`/ask/clienti/fatture/${data.numero}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="`${data.numero}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
            </template>
          </prime-column>
          <prime-column header="Stato">
            <template #body="{ data }">
              <Tag
                v-if="!isFatturaDaPagare(data)"
                severity="success"
                value="Pagata"
              />
              <Tag
                v-else-if="Number(data.pagato || 0) > 0"
                severity="warning"
                value="Pagata in parte"
              />
              <Tag v-else severity="danger" value="Da pagare" />
            </template>
          </prime-column>
          <prime-column header="Importo Fattura">
            <template #body="{ data }">
              {{
                currencyFormatter.format(
                  data.importo !== null ? data.importo : 0
                )
              }}
            </template>
          </prime-column>
          <prime-column header="Importo Pagato">
            <template #body="{ data }">
              {{
                currencyFormatter.format(
                  data.pagato !== null ? data.pagato : 0
                )
              }}
            </template>
          </prime-column>
          <prime-column header="Da Pagare">
            <template #body="{ data }">
              {{ currencyFormatter.format(residuoFattura(data)) }}
            </template>
          </prime-column>
          <prime-column field="data" header="Data Scadenza">
            <template #body="{ data }">
              {{
                data.data_scadenza !== null
                  ? moment(data.data_scadenza).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>
  </prime-accordion>

  <prime-accordion
    v-if="data.item.id"
    class="preview-fattura-accordion"
  >
    <prime-accordion-tab>
      <template #header>
        <span class="preview-fattura-accordion__title">
          <i class="pi pi-file-invoice preview-fattura-accordion__icon"></i>
          Preview Fattura
        </span>
      </template>
      <div>
        <prime-data-table
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 25, 50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
          :value="data.item.preview_fattura || []"
          responsiveLayout="scroll"
        >
          <prime-column field="p_code" header="PDR"></prime-column>

          <prime-column header="Contratto">
            <template #body="{ data }">
              <router-link
                v-if="data.cod_contratto"
                :to="`/ask/contratti/vendita/${data.cod_contratto}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="data.contratto || `${data.cod_contratto}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
              <span v-else>{{ data.contratto || "" }}</span>
            </template>
          </prime-column>

          <prime-column header="Cliente">
            <template #body="{ data }">
              <router-link
                v-if="data.cod_cliente"
                :to="`/ask/clienti/${data.cod_cliente}/dettagli`"
                custom
                v-slot="{ href }"
              >
                <prime-button
                  :label="data.cliente || `${data.cod_cliente}`"
                  class="p-button-info p-button-text"
                  @click="navigateToTab(href)"
                />
              </router-link>
              <span v-else>{{ data.cliente || "" }}</span>
            </template>
          </prime-column>

          <prime-column header="Mese Fatturazione">
            <template #body="{ data }">
              {{
                data.mese_fatturazione !== null
                  ? moment(data.mese_fatturazione)
                      .locale("it")
                      .format("MMMM YYYY")
                      .toUpperCase()
                  : ""
              }}
            </template>
          </prime-column>

          <prime-column header="Inizio Mese Fatturazione">
            <template #body="{ data }">
              {{
                data.inizio_mese_fatturazione !== null
                  ? moment(data.inizio_mese_fatturazione).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>

          <prime-column header="Fine Mese Fatturazione">
            <template #body="{ data }">
              {{
                data.fine_mese_fatturazione !== null
                  ? moment(data.fine_mese_fatturazione).format("DD/MM/YYYY")
                  : ""
              }}
            </template>
          </prime-column>

          <prime-column header="Imponibile">
            <template #body="{ data }">
              {{
                currencyFormatter.format(
                  data.imponibile !== null ? data.imponibile : 0
                )
              }}
            </template>
          </prime-column>

          <prime-column header="Totale Fattura">
            <template #body="{ data }">
              {{
                currencyFormatter.format(
                  data.totale_fattura !== null ? data.totale_fattura : 0
                )
              }}
            </template>
          </prime-column>
        </prime-data-table>
      </div>
    </prime-accordion-tab>
  </prime-accordion>

  <!-- Dialog add fattura voce -->
  <Dialog
    v-model:visible="fatturaVociDialog"
    :style="{ width: '90%' }"
    header="Aggiungi voce"
    :modal="true"
  >
    <div class="grid">
      <div class="field col-12 md:col-4">
        <label>Voce</label>
        <Dropdown
          v-model="newFatturavoce.voce"
          :options="fatturaVoci"
          optionLabel="descrizione"
          optionValue="id"
          dataKey="id"
          placeholder="Seleziona"
          :filter="true"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.voce && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.voce && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>Importo</label>
        <InputText
          type="number"
          v-model="newFatturavoce.importo"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.importo && submitted },
          ]"
          :value="newFatturavoce.importo"
        />
        <small class="p-error" v-if="validationErrors.importo && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>Aliquota</label>
        <InputNumber
          v-model="newFatturavoce.aliquota"
          mode="decimal"
          :minFractionDigits="2"
          :maxFractionDigits="2"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.aliquota && submitted },
          ]"
          :value="newFatturavoce.aliquota"
        />
        <small class="p-error" v-if="validationErrors.aliquota && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>Descrizione</label>
        <InputText
          v-model="newFatturavoce.descrizione"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.descrizione && submitted },
          ]"
          :value="newFatturavoce.descrizione"
        />
        <small class="p-error" v-if="validationErrors.descrizione && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-4">
        <label>Periodo</label>
        <Calendar
          v-model="newFatturavoce.periodo"
          :showIcon="true"
          selectionMode="range"
          view="month"
          dateFormat="mm-yy"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.periodo && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.periodo && submitted"
          >Campo richiesto</small
        >
      </div>
    </div>

    <div class="report" v-if="reportInsertFatturaVoci.length">
      <prime-data-table
        :paginator="true"
        :rows="10"
        :rowsPerPageOptions="[10, 25, 50]"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
        :value="reportInsertFatturaVoci"
        responsiveLayout="scroll"
      >
        <prime-column field="month" header="Mese"></prime-column>
        <prime-column field="msg" header="Messaggio"></prime-column>
        <prime-column field="success" header="Esito">
          <template #body="slotProps">
            <i v-if="slotProps.data.success" class="pi pi-check"></i>
            <i v-else class="pi pi-times"></i>
          </template>
        </prime-column>
      </prime-data-table>
    </div>

    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="fatturaVociDialog = false"
      />
      <Button
        label="Salva"
        :disabled="reportInsertFatturaVoci.length > 0"
        icon="pi pi-check"
        class="p-button-text"
        @click="addVoceInFattura"
      />
    </template>
  </Dialog>

  <!-- Dialog add new lettura -->
  <Dialog
    v-model:visible="letturaNewDialog"
    :style="{ width: '90%' }"
    header="Crea lettura"
    :modal="true"
  >
    <div class="grid">
      <div class="field col-12 md:col-6">
        <label>Data</label>
        <Calendar
          v-model="letturaNew.data"
          view="month"
          :manualInput="false"
          dateFormat="mm-yy"
          class="inputfield w-full"
        />
      </div>
      <div class="field col-12 md:col-6">
        <label>Consumo</label>
        <InputText
          type="number"
          v-model="letturaNew.consumo"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.consumo && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.consumo && submitted"
          >Campo richiesto</small
        >
      </div>
    </div>

    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="letturaNewDialog = false"
      />
      <Button
        label="Crea"
        icon="pi pi-check"
        class="p-button-text"
        @click="addNewLettura"
      />
    </template>
  </Dialog>

  <!-- Dialog all letture -->
  <Dialog
    v-model:visible="allLettureDialog"
    :style="{ width: '90%' }"
    header="Tutte le letture"
    :modal="true"
  >
    <div>
      <prime-data-table
        ref="all_letture"
        dataKey="id"
        :paginator="true"
        :rows="10"
        :rowsPerPageOptions="[10, 25, 50]"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
        :value="allLetture"
        responsiveLayout="scroll"
      >
        <template #header>
          <div class="flex justify-content-end flex-wrap">
            <div class="flex align-items-center justify-content-center">
              <Button
                icon="pi pi-external-link"
                label="Esporta"
                @click="exportCSV($event)"
                class="p-button-secondary"
              />
            </div>
          </div>
        </template>
        <template #empty>
          <div class="text-center">Nessun dato trovato.</div>
        </template>
        <prime-column field="data_misura" header="Data Misura">
          <template #body="{ data }">
            {{
              data.data_misura !== null
                ? moment(data.data_misura).format("DD/MM/YYYY")
                : ""
            }}
          </template>
        </prime-column>
        <prime-column field="consumo" header="Consumo">
          <template #body="{ data }">
            {{ data.consumo !== null ? data.consumo : 0 }}
          </template>
        </prime-column>
        <prime-column field="coeff" header="Coefficente">
          <template #body="{ data }">
            {{ data.coeff !== null ? data.coeff : 0 }}
          </template>
        </prime-column>
        <prime-column field="used" header="Usato" style="text-align: center">
          <template #body="{ data }">
            <i v-if="data.used" class="pi pi-check" />
            <i v-else class="pi pi-times" />
          </template>
        </prime-column>
        <prime-column field="type" header="Raccolta">
          <template #body="{ data }">
            {{ data.type }}
          </template>
        </prime-column>
        <prime-column field="tipolettura" header="Tipo lettura">
          <template #body="{ data }">
            {{ data.tipolettura }}
          </template>
        </prime-column>
        <prime-column field="autolettura" header="Autolettura">
          <template #body="{ data }">
            {{ data.autolettura ? "SI" : "NO" }}
          </template>
        </prime-column>
        <prime-column field="file" header="file" />
      </prime-data-table>
    </div>

    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="allLettureDialog = false"
      />
    </template>
  </Dialog>

  <Dialog
    v-model:visible="storicoAutoletturaDialog"
    :style="{ width: '540px' }"
    header="Storico autolettura"
    :modal="true"
    appendTo="body"
    class="storico-autolettura-dialog"
  >
    <div v-if="storicoAutoletturaLoading" class="storico-autolettura-state">
      <ProgressSpinner style="width: 40px; height: 40px" />
      <p>Caricamento storico...</p>
    </div>
    <div v-else-if="storicoAutoletturaError" class="storico-autolettura-alert">
      <i class="pi pi-exclamation-triangle" />
      <span>{{ storicoAutoletturaError }}</span>
    </div>
    <div v-else-if="storicoAutoletturaView.hasData" class="storico-autolettura-content">
      <section v-if="storicoAutoletturaView.valori.length" class="storico-section">
        <h4 class="storico-section-title">
          <i class="pi pi-chart-bar" />
          Valori
        </h4>
        <div class="storico-values-grid">
          <div
            v-for="item in storicoAutoletturaView.valori"
            :key="item.key"
            class="storico-value-card"
          >
            <span class="storico-value-label">{{ item.label }}</span>
            <span class="storico-value-number">{{ item.value }}</span>
          </div>
        </div>
      </section>

      <section v-if="storicoAutoletturaView.date.length" class="storico-section">
        <h4 class="storico-section-title">
          <i class="pi pi-calendar" />
          Date
        </h4>
        <div class="storico-info-list">
          <div
            v-for="item in storicoAutoletturaView.date"
            :key="item.key"
            class="storico-info-row"
          >
            <span class="storico-info-label">{{ item.label }}</span>
            <span class="storico-info-value">{{ item.value }}</span>
          </div>
        </div>
      </section>

      <section v-if="storicoAutoletturaView.utente.length" class="storico-section">
        <h4 class="storico-section-title">
          <i class="pi pi-user" />
          Utente
        </h4>
        <div class="storico-info-list">
          <div
            v-for="item in storicoAutoletturaView.utente"
            :key="item.key"
            class="storico-info-row"
          >
            <span class="storico-info-label">{{ item.label }}</span>
            <span
              class="storico-info-value"
              :class="{
                'storico-info-value--external': item.tone === 'external',
                'storico-info-value--internal': item.tone === 'internal',
              }"
            >{{ item.value }}</span>
          </div>
        </div>
      </section>

      <section class="storico-section">
        <h4 class="storico-section-title">
          <i class="pi pi-check-circle" />
          Conferma
        </h4>
        <div class="storico-info-list">
          <div
            v-for="item in storicoAutoletturaView.conferma"
            :key="item.key"
            class="storico-info-row"
          >
            <span class="storico-info-label">{{ item.label }}</span>
            <span
              class="storico-info-value"
              :class="{
                'storico-info-value--internal': item.tone === 'internal',
                'storico-info-value--system': item.tone === 'system',
              }"
            >{{ item.value }}</span>
          </div>
        </div>
      </section>
    </div>
    <div v-else class="storico-autolettura-state storico-autolettura-state--empty">
      <i class="pi pi-inbox" />
      <p>Nessun dato disponibile</p>
    </div>
    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="closeStoricoAutoletturaDialog"
      />
    </template>
  </Dialog>

  <Dialog
    v-model:visible="wizardCaricamentiLogsDialog"
    :style="{ width: '90%' }"
    header="Log modifiche caricamento wizard"
    :modal="true"
    :closable="true"
  >
    <div v-if="wizardCaricamentiLogsDialogRow" class="mb-3">
      <strong>Riga selezionata:</strong>
      {{ getWizardCaricamentiDialogTitle(wizardCaricamentiLogsDialogRow) }}
    </div>

    <div
      v-if="wizardCaricamentiLogs.length === 0"
      class="p-3 text-600"
    >
      Nessun log modifica disponibile
    </div>
    <prime-data-table
      v-else
      :value="wizardCaricamentiLogs"
      responsiveLayout="scroll"
      showGridlines
      scrollable
    >
      <prime-column field="id" header="ID Log" style="min-width: 110px">
        <template #body="{ data }">
          {{ data.id || "-" }}
        </template>
      </prime-column>
      <prime-column field="function" header="Function" style="min-width: 180px">
        <template #body="{ data }">
          {{ data.function || "-" }}
        </template>
      </prime-column>
      <prime-column field="data_inserimento" header="Data Inserimento" style="min-width: 180px">
        <template #body="{ data }">
          {{ formatWizardLogDate(data.data_inserimento) }}
        </template>
      </prime-column>
      <prime-column field="name_table" header="Tabella" style="min-width: 180px">
        <template #body="{ data }">
          {{ data.name_table || "-" }}
        </template>
      </prime-column>
      <prime-column field="id_record" header="ID Record" style="min-width: 120px">
        <template #body="{ data }">
          {{ data.id_record || "-" }}
        </template>
      </prime-column>
      <prime-column field="id_user" header="ID Utente" style="min-width: 120px">
        <template #body="{ data }">
          {{ data.id_user || "-" }}
        </template>
      </prime-column>
      <prime-column field="data_prev" header="Stato Precedente" style="min-width: 320px">
        <template #body="{ data }">
          <pre class="wizard-log-json">{{ formatWizardLogJson(data.data_prev) }}</pre>
        </template>
      </prime-column>
      <prime-column field="data_next" header="Stato Successivo" style="min-width: 320px">
        <template #body="{ data }">
          <pre class="wizard-log-json">{{ formatWizardLogJson(data.data_next) }}</pre>
        </template>
      </prime-column>
    </prime-data-table>

    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="wizardCaricamentiLogsDialog = false"
      />
    </template>
  </Dialog>

  <Dialog
    v-model:visible="wizardCaricamentoMatriceDialog"
    :style="{ width: '70%' }"
    header="Dettaglio caricamento multisito"
    :modal="true"
    :closable="true"
  >
    <div v-if="wizardCaricamentoMatriceId" class="mb-3">
      <strong>Matrice ID:</strong> {{ wizardCaricamentoMatriceId }}
    </div>

    <Loader v-if="wizardCaricamentoMatriceLoading" />
    <div
      v-else-if="wizardCaricamentoMatriceRows.length === 0"
      class="p-3 text-600"
    >
      Nessun dettaglio disponibile
    </div>
    <prime-data-table
      v-else
      :value="wizardCaricamentoMatriceRows"
      responsiveLayout="scroll"
      showGridlines
      scrollable
    >
      <prime-column field="field" header="Campo" style="min-width: 220px" />
      <prime-column field="value" header="Valore" style="min-width: 420px">
        <template #body="{ data }">
          <pre class="wizard-log-json">{{ data.value }}</pre>
        </template>
      </prime-column>
    </prime-data-table>

    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="wizardCaricamentoMatriceDialog = false"
      />
    </template>
  </Dialog>

  <Dialog
    v-model:visible="consumoGasDialog"
    :style="{ width: '50%' }"
    header="Aggiungi Consumo"
    :modal="true"
  >
    <div class="grid">
      <div class="field col-12 md:col-6">
        <label>Data</label>
        <PrimeCalendar
          v-model="newConsumoGas.data"
          view="month"
          :manualInput="false"
          dateFormat="mm-yy"
          class="inputfield w-full"
        />
      </div>
      <div class="field col-12 md:col-6">
        <label>Consumo</label>
        <PrimeInputText
          type="number"
          v-model="newConsumoGas.consumo"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.consumo && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.consumo && submitted"
          >Campo richiesto</small
        >
      </div>
      <div class="field col-12 md:col-6">
        <label>Tipo</label>
        <PrimeDropdown
          v-model="newConsumoGas.type"
          :options="typeOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Seleziona tipo"
          class="inputfield w-full"
        />
      </div>
      <div class="field col-12 md:col-6">
        <label>Coefficente</label>
        <PrimeInputText
          type="number"
          v-model="newConsumoGas.coeff"
          :class="[
            'inputfield w-full',
            { 'p-invalid': validationErrors.coeff && submitted },
          ]"
        />
        <small class="p-error" v-if="validationErrors.coeff && submitted"
          >Campo richiesto</small
        >
      </div>
    </div>

    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="consumoGasDialog = false"
      />
      <Button
        label="Salva"
        icon="pi pi-check"
        class="p-button-text"
        @click="addConsumoGas"
      />
    </template>
  </Dialog>
</template>

<script>
import PdrsService from "@/services/ask-management/pdrs-service";
import UtilityService from "@/services/ask-management/utility-service";
import AutoLetturaService from "@/services/ask-management/autolettura";

import Loader from "@/components/Loader.vue";
import SupplyPraticheSection from "@/components/ask/details/SupplyPraticheSection.vue";
import SupplyRiepilogoSection from "@/components/ask/details/SupplyRiepilogoSection.vue";
import PrimeAccordion from "primevue/accordion";
import PrimeAccordionTab from "primevue/accordiontab";
import PrimeDataTable from "primevue/datatable";
import PrimeColumn from "primevue/column";
import PrimeButton from "primevue/button";
import PrimeCalendar from "primevue/calendar";
import PrimeDropdown from "primevue/dropdown";
import PrimeInputNumber from "primevue/inputnumber";
import PrimeInputText from "primevue/inputtext";
import Dialog from "primevue/dialog";

import moment from "moment";
import { useRouter } from 'vue-router';
import { useStore } from "vuex";

export default {
  name: "ViewAskPdrsDetail",

  components: {
    Loader,
    SupplyPraticheSection,
    SupplyRiepilogoSection,
    PrimeAccordion,
    PrimeAccordionTab,
    PrimeDataTable,
    PrimeColumn,
    PrimeButton,
    PrimeCalendar,
    PrimeDropdown,
    PrimeInputNumber,
    PrimeInputText,
    Dialog,
  },

  data() {
    return {
      moment,
      loader: false,
      riusandoMensilitaIds: [],
      submitted: false,
      validationErrors: {},
      consumiDistributore: [],
      editingRowsConsumi: [],
      currencyFormatter: new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
      }),

      floatFixed2DigitFormatter: new Intl.NumberFormat("it-IT", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      floatFixed8DigitFormatter: new Intl.NumberFormat("it-IT", {
        minimumFractionDigits: 8,
        maximumFractionDigits: 8,
      }),

      route: {
        params: null,
      },

      isInEdit: false,
      oldInfo: null,

      fatturaVociDialog: false,
      fatturaVoci: [],
      newFatturavoce: {},
      reportInsertFatturaVoci: [],

      editingRowsLetture: [],
      letturaNewDialog: false,
      letturaNew: {
        data: new Date(),
        consumo: 0,
      },
      allLettureDialog: false,
      allLetture: [],

      storicoAutoletturaDialog: false,
      storicoAutoletturaLoading: false,
      storicoAutoletturaError: null,
      storicoAutoletturaData: null,
      wizardCaricamenti: [],
      wizardCaricamentiColumns: [],
      wizardCaricamentiLoading: false,
      wizardCaricamentiLoadedForCode: null,
      praticheData: null,
      wizardCaricamentiLogsDialog: false,
      wizardCaricamentiLogsDialogRow: null,
      wizardCaricamentiLogs: [],
      wizardCaricamentoMatriceDialog: false,
      wizardCaricamentoMatriceLoading: false,
      wizardCaricamentoMatriceId: null,
      wizardCaricamentoMatriceRows: [],

      consumoGasDialog: false,
      newConsumoGas: {
        data: null,
        consumo: 0,
        type: "L",
      },

      data: {
        allegato: {
          path: null,
          tipo: null,
          note: null,
        },

        booleanSelect: [
          { label: "NO", value: 0 },
          { label: "SI", value: 1 },
        ],
        disalimentabiliBoolean: [
          { label: "NO", value: "N" },
          { label: "SI", value: "Y" },
        ],
        comuni: [],
        tipiAllegato: [],
        tipiUso: [],
        tipiAccisa: [],
        item: {},
      },

      typeOptions: [{ label: "Consumo", value: "C" }],
      rapidCheckLoadingId: null,
      mensilitaFatturabiliKey: 0,
    };
  },

  watch: {
    "data.item.info.code": function (newCode) {
      if (newCode) {
        this.getConsumoGas(newCode);
      }
    },
  },

  created() {
    this.route.params = this.$route.params;

    this.pdrsService = new PdrsService(this.$http, this.$eventBus);
    this.autoLetturaService = new AutoLetturaService(this.$eventBus);
    this.getDettaglioPdr(this.route.params.id);

    this.utilityService = new UtilityService(this.$http, this.$eventBus);
    this.getComuni();
    this.getTipiAllegato();
    this.getTipiUso();
    this.getFatturaVoci();
    this.getTypeAccisa();
  },

  methods: {
    onDetailAccordionTabOpen(evt) {
      if (evt.index === 1) {
        this.loadWizardCaricamentiByCode();
      }
    },

    getPdrCode() {
      return String(this.data?.item?.info?.code || "").trim();
    },

    extractWizardCaricamentiColumns(items) {
      const columns = new Set();

      items.forEach((item) => {
        if (item && typeof item === "object" && !Array.isArray(item)) {
          Object.keys(item).forEach((key) => columns.add(key));
        }
      });

      const orderedColumns = Array.from(columns);
      const logsColumnIndex = orderedColumns.indexOf("logs_modifiche");

      if (logsColumnIndex > 0) {
        orderedColumns.splice(logsColumnIndex, 1);
        orderedColumns.unshift("logs_modifiche");
      }

      return orderedColumns;
    },

    formatWizardCaricamentiValue(value) {
      if (value === null || typeof value === "undefined") {
        return "";
      }

      if (typeof value === "object") {
        return JSON.stringify(value);
      }

      return value;
    },

    hasWizardCaricamentiLogs(logs) {
      return Array.isArray(logs) && logs.length > 0;
    },

    parseWizardLogJson(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return null;
      }

      if (typeof value === "object") {
        return value;
      }

      try {
        return JSON.parse(value);
      } catch (error) {
        return value;
      }
    },

    formatWizardLogJson(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return "";
      }

      if (typeof value === "string") {
        return value;
      }

      return JSON.stringify(value, null, 2);
    },

    formatWizardLogDate(value) {
      if (!value) {
        return "";
      }

      return moment(value).format("DD/MM/YYYY HH:mm");
    },

    getWizardCaricamentiDialogTitle(rowData) {
      return (
        rowData?.id ||
        rowData?.code ||
        rowData?.pdr_code ||
        rowData?.codice_pdr ||
        rowData?.codice ||
        "-"
      );
    },

    extractWizardCaricamentoMatriceRows(item) {
      if (!item || typeof item !== "object" || Array.isArray(item)) {
        return [];
      }

      return Object.entries(item).map(([field, value]) => ({
        field,
        value: this.formatWizardLogJson(this.parseWizardLogJson(value)),
      }));
    },

    openWizardCaricamentiLogsDialog(rowData) {
      const logs = Array.isArray(rowData?.logs_modifiche)
        ? rowData.logs_modifiche
        : [];

      this.wizardCaricamentiLogsDialogRow = rowData;
      this.wizardCaricamentiLogs = logs.map((log, index) => ({
        ...log,
        _index: index + 1,
        data_prev: this.parseWizardLogJson(log?.data_prev),
        data_next: this.parseWizardLogJson(log?.data_next),
      }));
      this.wizardCaricamentiLogsDialog = true;
    },

    async openWizardCaricamentoMatriceDialog(matriceId) {
      if (!matriceId) {
        return;
      }

      this.wizardCaricamentoMatriceDialog = true;
      this.wizardCaricamentoMatriceLoading = true;
      this.wizardCaricamentoMatriceId = matriceId;
      this.wizardCaricamentoMatriceRows = [];

      try {
        const result = await this.utilityService.getCaricamentoWizardByMatriceId(
          matriceId
        );
        this.wizardCaricamentoMatriceRows =
          this.extractWizardCaricamentoMatriceRows(result?.item);
      } finally {
        this.wizardCaricamentoMatriceLoading = false;
      }
    },

    async loadWizardCaricamentiByCode() {
      const code = this.getPdrCode();

      if (!code || this.wizardCaricamentiLoading) {
        return;
      }

      if (this.wizardCaricamentiLoadedForCode === code) {
        return;
      }

      this.wizardCaricamentiLoading = true;

      try {
        const result = await this.pdrsService.getCaricamentiWizardByCode(code);
        this.wizardCaricamenti = Array.isArray(result?.items)
          ? result.items
          : [];
        this.wizardCaricamentiColumns = this.extractWizardCaricamentiColumns(
          this.wizardCaricamenti
        );
        this.wizardCaricamentiLoadedForCode = code;
      } finally {
        this.wizardCaricamentiLoading = false;
      }
    },

    onRowEditInitConsumo(event) {
      this.originalConsumoData = { ...event.data };
    },

    onRowEditCancelConsumo(event) {
      const index = event.index;
      this.$set(this.consumiDistributore, index, this.originalConsumoData);
    },

    async onRowEditLetturaComplete(event) {
      const updatedLettura = { ...event.newData };

      try {
        const response = await this.pdrsService.updateConsumoGas({
          id: updatedLettura.id,
          consumo: updatedLettura.consumo,
          coeff: updatedLettura.coeff,
          data_misura: updatedLettura.data_misura,
          data_comunicazione: updatedLettura.data_comunicazione,
          pdr_id: this.data.item.id
        });

        if (response.item) {
          const index = this.data.item.letture.findIndex(
            (lettura) => lettura.id === response.item.id
          );

          if (index !== -1) {
            this.data.item.letture[index] = {
              ...response.item,
            };
          }

          this.editingRowsLetture = []; 

          this.$toast.add({
            severity: "success",
            summary: "Modifica completata",
            detail: "La lettura è stata aggiornata con successo.",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Errore",
            detail: "Impossibile aggiornare la lettura.",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Errore durante l'aggiornamento della lettura:", error);
        this.$toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante l'aggiornamento della lettura.",
          life: 3000,
        });
      }
    },

    navigateToTab(href) {
      window.open(href, "_blank");
    },

    residuoFattura(fattura) {
      return Number(fattura.importo || 0) - Number(fattura.pagato || 0);
    },

    isFatturaDaPagare(fattura) {
      return this.residuoFattura(fattura) > 0.005;
    },

    fatturaRowClass(fattura) {
      return this.isFatturaDaPagare(fattura) ? "fattura-da-pagare" : null;
    },

    async loadPraticheFornitori(id) {
      try {
        const result = await this.pdrsService.getPraticheFornitori(id);
        const data = result?.item || {};

        this.praticheData = {
          fornitori: data.fornitori || [],
          pratiche: data.pratiche || [],
          pratiche_gestione: data.pratiche_gestione || [],
        };
      } catch (error) {
        console.error(error);
        this.praticheData = {
          fornitori: [],
          pratiche: [],
          pratiche_gestione: [],
        };
      }
    },

    async getDettaglioPdr(id) {
      this.praticheData = null;
      const res = await this.pdrsService.getDettaglioPdr(id);
      this.data.item = res.item;
      this.data.item.info.sospendibile = Boolean(this.data.item.info.sospendibile);

      if (!this.data.item.preview_fattura) {
        this.data.item.preview_fattura = [];
      }

      this.loadPraticheFornitori(res.item.id);
      
      await this.loadRcuGasData();

      if (this.data.item.info?.code) {
        this.getConsumoGas(this.data.item.info.code);
      }

      document.title = 'info' in this.data.item
        ? 'code' in this.data.item.info
          ? document.title + ' - ' + this.data.item.info.code
          : document.title
        : document.title;
    },

    getComuni() {
      this.utilityService.getComuni().then((res) => {
        this.data.comuni = res.items;
      });
    },

    getTipiAllegato() {
      this.utilityService.getTipiAllegato().then((res) => {
        this.data.tipiAllegato = res.items;
      });
    },

    getTypeAccisa() {
      this.utilityService.getTypeAccisa().then((res) => {
        this.data.tipiAccisa = res.items;
      });
    },

    getTipiUso() {
      this.utilityService.getTipiUso().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });

        this.data.tipiUso = res.items;
      });
    },

    onAllegatiUpload() {
      this.$toast.add({
        severity: "info",
        summary: "Success",
        detail: "Caricato allegato",
        life: 3000,
      });
    },

    onEditInfo() {
      this.oldInfo = JSON.stringify(this.data.item.info);
      this.isInEdit = true;
    },

    onAbortInfoEdit() {
      this.data.item.info = JSON.parse(this.oldInfo);

      this.oldInfo = null;
      this.isInEdit = !this.isInEdit;
    },

    onUpdateInfo() {
      const allowed = [
        "toponimo",
        "indirizzo",
        "civico",
        "cap",
        "matricola",
        "classe",
        "remi",
        "consumo_annuo",
        "fatturazione_solo_reale",
        "cod_type_uso",
        "cod_comune",
        "cod_type_accisa",
        "sospendibile",
        "CIG",
        "CUP"
      ];

      const info = Object.keys(this.data.item.info)
        .filter((key) => allowed.includes(key))
        .reduce((obj, key) => {
          return {
            ...obj,
            [key]: this.data.item.info[key],
          };
        }, {});

      if (info.cod_comune == -1) {
        info.cod_comune = null;
      }
      if (info.cod_type_uso == -1) {
        info.cod_type_uso = null;
      }

      if (this.oldInfo != JSON.stringify(this.data.item.info)) {
        this.pdrsService.updateInfo(this.data.item.id, info).then((res) => {
          if (res.success) {
            delete res.item.id;
            this.data.item.info = res.item;
            this.data.item.info.sospendibile = Boolean(this.data.item.info.sospendibile);
          }
        });
      }

      this.oldInfo = null;
      this.isInEdit = !this.isInEdit;
    },

    onVoltura() {
      alert("Voltura");
    },
    getLetture() {
      this.loader = true;
      this.pdrsService
        .getLetture(this.route.params.id)
        .then((res) => {
          this.data.item.letture = res.items;
        })
        .finally(() => {
          this.loader = false;
        });
    },
    addNewLettura() {
      this.loader = true;
      this.submitted = true;
      if (this.validateNewLettura()) {
        let obj = JSON.parse(JSON.stringify(this.letturaNew));
        obj.data = moment(obj.data).format("YYYY-MM-DD");
        obj.fornitura_code = this.data.item.info.code;
        this.pdrsService
          .addNewLettura(obj)
          .then((res) => {
            if (res.item) {
              this.letturaNewDialog = false;
              this.getLetture();
              this.$toast.add({
                severity: "info",
                summary: "Successo",
                detail: "Lettura caricata",
                life: 3000,
              });
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Errore",
                detail: "Errore caricamento",
                life: 3000,
              });
            }
          })
          .finally(() => {
            this.loader = false;
          });
      }
    },
    downloadLettura(data) {
      this.loader = true;
      this.pdrsService.downloadLettura(data.id).finally(() => {
        this.loader = false;
      });
    },

    riusaLettura(data) {
      this.loader = true;
      this.pdrsService
        .riusaLettura(data.id)
        .then((res) => {
          if (res.item) {
            this.$toast.add({
              severity: "info",
              summary: "Successo",
              detail: "Lettura riutilizzabile",
              life: 3000,
            });
            this.getDettaglioPdr(this.data.item.id);
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    eliminaLettura(data) {
      if (data.autolettura) {
        this.loader = true;
        this.pdrsService
          .eliminaLettura(data.id)
          .then((res) => {
            if (res.item) {
              this.$toast.add({
                severity: "info",
                summary: "Successo",
                detail: "Lettura eliminata",
                life: 3000,
              });
              this.getDettaglioPdr(this.data.item.id);
            }
          })
          .finally(() => {
            this.loader = false;
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Info",
          detail: "Lettura non eliminabile",
          life: 3000,
        });
      }
    },

    getAutoletturaId(lettura) {
      const rawId = lettura?.id_autolettura;

      if (rawId === null || rawId === undefined || rawId === "") {
        return null;
      }

      const parsed = Number(rawId);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    },

    hasAutoletturaId(lettura) {
      return this.getAutoletturaId(lettura) !== null;
    },

    buildStoricoAutoletturaView(record) {
      const emptyView = { valori: [], date: [], utente: [], conferma: [], hasData: false };

      if (!record || typeof record !== "object") {
        return emptyView;
      }

      const valoriFields = [
        { key: "a1", label: "F1" },
        { key: "a2", label: "F2" },
        { key: "a3", label: "F3" },
        { key: "r1", label: "R1" },
        { key: "r2", label: "R2" },
        { key: "r3", label: "R3" },
        { key: "p1", label: "P1" },
        { key: "p2", label: "P2" },
        { key: "p3", label: "P3" },
        { key: "mq", label: "MQ" },
        { key: "coeff", label: "Coefficiente" },
      ];

      const dateFields = [
        { key: "data_autolettura", label: "Data autolettura" },
        { key: "date_conferma_autolettura", label: "Data conferma" },
        { key: "data_inserimento", label: "Data inserimento" },
        { key: "data_riferimento", label: "Data riferimento" },
      ];

      const hasValue = (value) =>
        value !== null && value !== undefined && value !== "";

      const formatStoricoDate = (value) => {
        const parsed = this.moment(value);
        return parsed.isValid() ? parsed.format("DD/MM/YYYY HH:mm") : value;
      };

      const formatStoricoNumber = (value) => {
        const parsed = Number(value);
        if (!Number.isFinite(parsed)) {
          return value;
        }

        return Number.isInteger(parsed)
          ? String(parsed)
          : parsed.toLocaleString("it-IT", { maximumFractionDigits: 3 });
      };

      const valori = valoriFields
        .filter(({ key }) => hasValue(record[key]))
        .map(({ key, label }) => ({
          key,
          label,
          value: formatStoricoNumber(record[key]),
        }));

      const date = dateFields
        .filter(({ key }) => hasValue(record[key]))
        .map(({ key, label }) => ({
          key,
          label,
          value: formatStoricoDate(record[key]),
        }));

      const utente = [];
      const emailValue = hasValue(record.email) ? String(record.email).trim() : "";

      if (emailValue) {
        utente.push({
          key: "tipo_inserimento",
          label: "Inserita da",
          value: "Utente esterno",
          tone: "external",
        });
        utente.push({
          key: "email",
          label: "Email",
          value: emailValue,
        });
      } else {
        utente.push({
          key: "tipo_inserimento",
          label: "Inserita da",
          value: "Utente interno",
          tone: "internal",
        });

        if (hasValue(record.user)) {
          utente.push({
            key: "user",
            label: "Utente",
            value: record.user,
          });
        }
      }

      const conferma = [
        {
          key: "confermata_da",
          label: "Confermata da",
          value: hasValue(record.user_id)
            ? hasValue(record.user)
              ? record.user
              : record.user_id
            : "Sistema",
          tone: hasValue(record.user_id) ? "internal" : "system",
        },
      ];

      return {
        valori,
        date,
        utente,
        conferma,
        hasData: valori.length + date.length + utente.length + conferma.length > 0,
      };
    },

    async openStoricoAutoletturaDialog(lettura) {
      this.storicoAutoletturaDialog = true;
      this.storicoAutoletturaLoading = false;
      this.storicoAutoletturaError = null;
      this.storicoAutoletturaData = null;

      const id = this.getAutoletturaId(lettura);

      if (!id) {
        this.storicoAutoletturaError = "ID autolettura non disponibile";
        return;
      }

      this.storicoAutoletturaLoading = true;

      try {
        const res = await this.autoLetturaService.getStoricoAutolettura(id);
        const payload = res?.data?.success !== undefined ? res.data : res;

        if (payload?.success && payload?.data) {
          this.storicoAutoletturaData = payload.data;
        } else {
          this.storicoAutoletturaError =
            payload?.message || "Impossibile recuperare lo storico autolettura";
        }
      } catch (error) {
        this.storicoAutoletturaError =
          error?.response?.data?.message ||
          "Errore durante il recupero dello storico autolettura";
      } finally {
        this.storicoAutoletturaLoading = false;
      }
    },

    closeStoricoAutoletturaDialog() {
      this.storicoAutoletturaDialog = false;
      this.storicoAutoletturaLoading = false;
      this.storicoAutoletturaError = null;
      this.storicoAutoletturaData = null;
    },

    viewAllLetture() {
      if (
        this.data.item &&
        "info" in this.data.item &&
        this.data.item.info.code
      ) {
        this.loader = true;
        this.utilityService
          .viewAllLetture(this.data.item.info.code, "pdr")
          .then((res) => {
            this.allLettureDialog = true;
            this.allLetture = res.items;
          })
          .finally(() => {
            this.loader = false;
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Info",
          detail: "Dati non disponibili",
          life: 3000,
        });
      }
    },
    getFatturaVoci() {
      this.utilityService.getFatturaVoci().then((res) => {
        this.fatturaVoci = res.items.data;
      });
    },

    addVoceInFattura() {
      this.loader = true;
      this.reportInsertFatturaVoci = [];
      this.submitted = true;
      if (this.validateFormFatturaVoce()) {
        let obj = JSON.parse(JSON.stringify(this.newFatturavoce));
        obj.fornitura_id = this.data.item.id;
        obj.periodo[0] = moment(this.newFatturavoce.periodo[0]).format(
          "DD-MM-YYYY"
        );
        obj.periodo[1] =
          this.newFatturavoce.periodo[1] != null
            ? moment(this.newFatturavoce.periodo[1]).format("DD-MM-YYYY")
            : moment(this.newFatturavoce.periodo[0]).format("DD-MM-YYYY");
        this.utilityService
          .addVoceInFattura([obj], "gas")
          .then((res) => {
            this.reportInsertFatturaVoci = res.items;
            this.getDettaglioPdr(this.data.item.id);
          })
          .finally(() => {
            this.loader = false;
          });
      }
    },

    openFatturaVociDialog() {
      this.reportInsertFatturaVoci = [];
      this.submitted = false;
      this.fatturaVociDialog = true;
    },

    onDeleteFatturaVoce(voce) {
      this.utilityService.onDeleteFatturaVoce(voce.id, "pdr").then((res) => {
        if (res && res.success) {
          this.getDettaglioPdr(this.data.item.id);
        } else if (
          res &&
          res.message &&
          res.message.includes("Impossibile eliminare: la voce è in uso")
        ) {
          this.$toast.add({
            severity: "warn",
            summary: "Attenzione",
            detail: "voce già in uso",
            life: 3000,
          });
        }
      });
    },

    formatContrattoVenditaDataFine(contratto) {
      const dataFine = contratto?.data_fine;
      return dataFine ? moment(dataFine).format("DD/MM/YYYY") : "";
    },

    isContrattoVenditaDataFineEditable(contratto) {
      if (!contratto?.c_id) {
        return false;
      }

      const contrattoCorrenteId = Number(this.data.item.cod_contratto);
      if (contrattoCorrenteId > 0 && Number(contratto.c_id) === contrattoCorrenteId) {
        return false;
      }

      return true;
    },

    getContrattoVenditaApiErrorMessage(result) {
      if (result.message) {
        return result.message;
      }

      if (result.validate) {
        const messages = Object.values(result.validate).flat();
        if (messages.length) {
          return messages.join(" ");
        }
      }

      return "Impossibile aggiornare la data fine del contratto.";
    },

    onCellContrattoVenditaEditInit(event) {
      if (event.field !== "data_fine") {
        return;
      }

      if (!this.isContrattoVenditaDataFineEditable(event.data)) {
        return;
      }

      const dataFine = event.data.data_fine;
      event.data._originalDataFine = dataFine
        ? moment(dataFine).format("YYYY-MM-DD")
        : null;

      if (dataFine) {
        const parsedDate = moment(dataFine).toDate();
        event.data._editDataFine = !isNaN(parsedDate.valueOf())
          ? parsedDate
          : null;
      } else {
        event.data._editDataFine = null;
      }
    },

    async confirmContrattoVenditaDataFine(contratto, editorCancelCallback) {
      if (!this.isContrattoVenditaDataFineEditable(contratto)) {
        return;
      }

      if (!contratto._editDataFine) {
        this.$toast.add({
          severity: "warn",
          summary: "Data mancante",
          detail: "Seleziona una data fine valida.",
          life: 3000,
        });
        return;
      }

      const nuovaDataFine = moment(contratto._editDataFine).format("YYYY-MM-DD");

      if (
        contratto._originalDataFine &&
        nuovaDataFine === contratto._originalDataFine
      ) {
        if (typeof editorCancelCallback === "function") {
          editorCancelCallback();
        }
        return;
      }

      if (typeof editorCancelCallback === "function") {
        editorCancelCallback();
      }

      this.loader = true;

      try {
        const result = await this.pdrsService.changeDataFineContrattoVendita(
          this.data.item.id,
          contratto.c_id,
          nuovaDataFine
        );

        if (result.success) {
          await this.getDettaglioPdr(this.data.item.id);
          this.$toast.add({
            severity: "success",
            summary: "Successo",
            detail: "Data fine contratto aggiornata",
            life: 3000,
          });
        } else {
          await this.getDettaglioPdr(this.data.item.id);
          this.$toast.add({
            severity: "error",
            summary: "Errore",
            detail: this.getContrattoVenditaApiErrorMessage(result),
            life: 5000,
          });
        }
      } finally {
        delete contratto._editDataFine;
        delete contratto._originalDataFine;
        this.loader = false;
      }
    },

    onCellRcusDateEditComplete(event) {
      this.loader = true;
      let obj = { ...event.newData };
      obj[event.field] = moment(event.newValue).format("YYYY-MM-DD");
      obj.fornitura_id = this.data.item.id;
      this.utilityService
        .updateDateRcu(obj, "pdr")
        .then((res) => {
          if (res.item == 1) {
            this.getDettaglioPdr(this.data.item.id);
            this.$toast.add({
              severity: "info",
              summary: "Successo",
              detail: "Data modificata",
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    onCambiaOfferta() {
      const ids = [this.route.params.id];

      this.$eventBus.emit("show-dialog-page", {
        page: "pdrs-cambia-offerta",
        title: "Cambia Offerta Pdrs",
        data: ids,
        maximize: false,

        buttonOk: {
          label: "Chiudi",
          icon: "pi pi-times",
          class: "p-button-text",
          visible: true,
          disabled: false,
        },

        buttonCancel: {
          label: "",
          icon: "",
          class: "",
          visible: false,
          disabled: false,
        },
      });
    },

    openConsumoGasDialog() {
      this.consumoGasDialog = true;
      this.submitted = false;
      this.newConsumoGas = {
        data: null,
        consumo: 0,
        type: "L",
      };
    },

    async addConsumoGas() {
      this.submitted = true;
      if (this.validateNewConsumoGas()) {
        const formattedData = {
          valore: this.newConsumoGas.consumo,
          data: moment(this.newConsumoGas.data)
            .startOf("month")
            .format("DD-MM-YYYY"),
          type: this.newConsumoGas.type,
          coeff: this.newConsumoGas.coeff,
          id: this.data.item.id,
          saveconsumo: true,
        };

        const response = await this.utilityService.addConsumoGas(
          formattedData,
          this.data.item.info.code
        );

        if (response.success) {
          this.consumiDistributore.push({
            ...response.data,
            data_misura: response.data.data_misura
              ? moment(response.data.data_misura)
                  .locale("it")
                  .format("MMMM YYYY")
                  .toUpperCase()
              : "",
          });

          this.consumiDistributore = [...this.consumiDistributore];

          this.$nextTick(() => {
            this.$toast.add({
              severity: "success",
              summary: "Successo",
              detail: response.message,
              life: 3000,
            });
          });

          this.consumoGasDialog = false;
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Errore",
            detail: response.message,
            life: 3000,
          });
        }
      }
    },

    getConsumoGas(code) {
      if (!code) {
        this.consumiDistributore = [];
        return;
      }

      this.loader = true;

      this.utilityService
        .getConsumoGas(code)
        .then((response) => {
          if (response.success && Array.isArray(response.items)) {
            this.consumiDistributore = response.items.map((item) => ({
              ...item,
              data_misura: moment(item.data_misura).format("MM/YYYY"),
              tipolettura: item.tipolettura || "Non specificato",
              autolettura: Boolean(item.autolettura),
              used: Boolean(item.used),
            }));
          } else {
            this.consumiDistributore = [];
            if (!response.success) {
              console.error("Errore nel recupero dei dati del consumo");
            }
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    onDeleteConsumoGas(consumoId) {
      this.loader = true;

      this.pdrsService
        .deleteConsumoGas(this.route.params.id, consumoId)
        .then((res) => {
          if (res.success) {
            this.consumiDistributore = this.consumiDistributore.filter(
              (consumo) => consumo.id !== consumoId
            );

            this.$toast.add({
              severity: "success",
              summary: "Successo",
              detail: "Consumo eliminato",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Errore",
              detail: "Errore durante l'eliminazione",
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    validateNewConsumoGas() {
      this.validationErrors = {};
      this.validationErrors.consumo = this.newConsumoGas.consumo <= 0;
      this.validationErrors.data = !this.newConsumoGas.data;
      this.validationErrors.coeff = this.newConsumoGas.coeff <= 0;
      return !Object.keys(this.validationErrors).some(
        (key) => this.validationErrors[key]
      );
    },

    validateFormFatturaVoce() {
      this.validationErrors = {};

      if (this.newFatturavoce.voce && this.newFatturavoce.voce != "")
        delete this.validationErrors["voce"];
      else this.validationErrors["voce"] = true;

      if (this.newFatturavoce.importo && this.newFatturavoce.importo != "")
        delete this.validationErrors["importo"];
      else this.validationErrors["importo"] = true;

      if (this.newFatturavoce.aliquota && this.newFatturavoce.aliquota != "")
        delete this.validationErrors["aliquota"];
      else this.validationErrors["aliquota"] = true;

      if (
        this.newFatturavoce.descrizione &&
        this.newFatturavoce.descrizione != ""
      )
        delete this.validationErrors["descrizione"];
      else this.validationErrors["descrizione"] = true;

      if (this.newFatturavoce.periodo) delete this.validationErrors["periodo"];
      else this.validationErrors["periodo"] = true;

      return !Object.keys(this.validationErrors).length;
    },
    validateNewLettura() {
      this.validationErrors = {};

      if (parseFloat(this.letturaNew.consumo) >= 0)
        delete this.validationErrors["consumo"];
      else this.validationErrors["consumo"] = true;

      return !Object.keys(this.validationErrors).length;
    },
    exportCSV() {
      this.$refs.all_letture.exportCSV();
    },
    async loadRcuGasData() {
      if (this.data.item && this.data.item.id) {
        try {
          const result = await this.pdrsService.getDatiRcuGas(this.data.item.id);
          this.data.item.rcus_gas = result.dati_gas;
        } catch (error) {
          console.error('Errore nel caricamento dei dati RCU Gas:', error);
          this.$toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Impossibile caricare i dati RCU Gas',
            life: 3000
          });
        }
      }
    },

    onDeleteMensilitaRealeGas(pdrId, mensilitaId) {
      this.pdrsService.deleteMensilitaRealeGas(pdrId, mensilitaId).then((res) => {
        if (res.success) {
          this.getDettaglioPdr(this.data.item.id);
        }
      });
    },

    canRiusaMensilitaReale(row) {
      const usedFt = row?.used_ft;
      return usedFt == null || String(usedFt).trim() === "";
    },
    isRiusaMensilitaRealeDisabled(row) {
      return (
        Number(row?.used) === 0 ||
        this.riusandoMensilitaIds.includes(Number(row?.id))
      );
    },
    onMensilitaRealeUsed2Gas(pdrId, mensilitaId) {
      this.pdrsService.mensilitaRealeUsed2Gas(pdrId, mensilitaId).then((res) => {
        if (res.success) {
          this.getDettaglioPdr(this.data.item.id);
        }
      });
    },
    onRiusaMensilitaRealeGas(pdrId, mensilitaId) {
      const rows = this.data.item.mesilita_reali || [];
      const row = rows.find((item) => Number(item.id) === Number(mensilitaId));
      if (!row || this.isRiusaMensilitaRealeDisabled(row)) {
        return;
      }

      this.riusandoMensilitaIds.push(Number(mensilitaId));
      this.pdrsService.riusaMensilitaRealeGas(pdrId, mensilitaId).then((res) => {
        if (res.success) {
          row.used = 0;
          this.$toast.add({
            severity: "info",
            summary: "Successo",
            detail: "Mensilità reale riutilizzabile",
            life: 3000,
          });
          this.getDettaglioPdr(this.data.item.id);
        } else {
          this.riusandoMensilitaIds = this.riusandoMensilitaIds.filter(
            (id) => id !== Number(mensilitaId)
          );
          this.$toast.add({
            severity: "warn",
            summary: "Attenzione",
            detail: "Impossibile riusare la mensilità reale",
            life: 3000,
          });
        }
      });
    },

    isRapidChecked(row) {
      return Number(row?.rapidCheck) === 1;
    },

    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    },

    formatRapidCheckDate(date) {
      return date ? moment(date).format('DD/MM/YYYY HH:mm') : '';
    },

    applyRapidCheckToRow(rowId, dataRapidCheck) {
      const mensilita = this.data.item.mensilita_fatturabili || [];
      const target = mensilita.find((item) => Number(item.id) === Number(rowId));
      if (!target) {
        return;
      }
      target.rapidCheck = 1;
      target.data_rapidCheck = dataRapidCheck;
    },

    async onRapidCheck(row) {
      if (!row?.id || !row.cod_pdr || !row.mese || !row.fine || this.isRapidChecked(row) || this.rapidCheckLoadingId === row.id) {
        return;
      }

      this.rapidCheckLoadingId = row.id;

      try {
        const result = await this.pdrsService.setRapidCheckFatturabile(row);

        if (result.success) {
          this.applyRapidCheckToRow(
            result.data?.id || row.id,
            result.data?.data_rapidCheck || moment().format('YYYY-MM-DD HH:mm:ss')
          );
          this.$toast.add({
            severity: 'success',
            summary: 'Richiesta Conguaglio',
            detail: 'Richiesta conguaglio salvata',
            life: 2500,
          });
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Impossibile salvare il check rapido',
            life: 3000,
          });
        }
      } catch (error) {
        console.error('Errore Check Rapido:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile salvare il check rapido',
          life: 3000,
        });
      } finally {
        this.rapidCheckLoadingId = null;
      }
    },

    onMensilitaFatturabileCellEditInit(event) {
      const row = event?.data;
      if (!row) {
        return;
      }
      if (row._originalInizio === undefined) {
        row._originalInizio = row.inizio ?? null;
      }
      if (row._originalFine === undefined) {
        row._originalFine = row.fine ?? null;
      }
    },

    formatFatturabileApiDate(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }
      const parsed = moment(value);
      return parsed.isValid() ? parsed.format("YYYY-MM-DD") : value;
    },

    restoreMensilitaFatturabileDates(row, originals) {
      if (!row || !originals) {
        return;
      }
      row.inizio = originals.inizio;
      row.fine = originals.fine;
    },

    clearMensilitaFatturabileOriginals(row) {
      if (!row) {
        return;
      }
      delete row._originalInizio;
      delete row._originalFine;
    },

    async confirmEdit(data, field, cancelCallback) {
      const originals = {
        inizio: data?._originalInizio !== undefined ? data._originalInizio : data?.inizio,
        fine: data?._originalFine !== undefined ? data._originalFine : data?.fine,
      };
      const payload = {
        ...data,
        inizio: this.formatFatturabileApiDate(data?.inizio),
        fine: this.formatFatturabileApiDate(data?.fine),
      };
      const target = (this.data.item.mensilita_fatturabili || []).find(
        (item) => Number(item.id) === Number(data?.id)
      );

      try {
        if (typeof cancelCallback === "function") {
          cancelCallback();
        }

        const result = await this.pdrsService.updateMensilitaFatturabile(payload);

        if (result.success) {
          if (target) {
            target.inizio = payload.inizio;
            target.fine = payload.fine;
          }
          this.clearMensilitaFatturabileOriginals(target || data);
          this.$toast.add({
            severity: "success",
            summary: "Aggiornamento riuscito",
            detail: "Le date sono state aggiornate con successo",
            life: 3000,
          });
          this.mensilitaFatturabiliKey += 1;
        } else {
          this.restoreMensilitaFatturabileDates(target, originals);
          this.restoreMensilitaFatturabileDates(data, originals);
          this.clearMensilitaFatturabileOriginals(target || data);
          this.mensilitaFatturabiliKey += 1;
          this.$toast.add({
            severity: "error",
            summary: "Errore",
            detail: "Impossibile aggiornare le date",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Errore durante l'aggiornamento:", error);
        this.restoreMensilitaFatturabileDates(target, originals);
        this.restoreMensilitaFatturabileDates(data, originals);
        this.clearMensilitaFatturabileOriginals(target || data);
        this.mensilitaFatturabiliKey += 1;
        this.$toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Si è verificato un errore durante l'aggiornamento",
          life: 3000,
        });
      }
    },

    onDateSelect(event, rowData, field) {
      rowData[field] = moment(event).format("YYYY-MM-DD");
    },

    getFirstDayOfMonth(dateString) {
      if (!dateString) return null;
      return moment(dateString).clone().startOf("month").toDate();
    },

    getLastDayOfMonth(dateString) {
      if (!dateString) return null;
      return moment(dateString).clone().endOf("month").toDate();
    },

    onRowEditInit(data) {
      this.editingRowsLetture = [data];
    },

    onRowEditCancel() {
      this.editingRowsLetture = [];
    },
  },

  computed: {
    storicoAutoletturaView() {
      return this.buildStoricoAutoletturaView(this.storicoAutoletturaData);
    },

    dataInizio: {
      get: function () {
        const info = this.data?.item?.info;
        if (!info) {
          return null;
        }

        return info.data_inizio !== null &&
          info.data_inizio !== ""
          ? moment(info.data_inizio).toDate()
          : null;
      },
      set: function (value) {
        const info = this.data?.item?.info;
        if (!info) {
          return;
        }

        if (value instanceof Date && !isNaN(value.valueOf())) {
          info.data_inizio = moment(value).format("YYYY-MM-DD");
        }

        if (value === null || value === "") {
          info.data_inizio = null;
        }
      },
    },

    dataFine: {
      get: function () {
        const info = this.data?.item?.info;
        if (!info) {
          return null;
        }

        return info.data_fine !== null &&
          info.data_fine !== ""
          ? moment(info.data_fine).toDate()
          : null;
      },
      set: function (value) {
        const info = this.data?.item?.info;
        if (!info) {
          return;
        }

        if (value instanceof Date && !isNaN(value.valueOf())) {
          info.data_fine = moment(value).format("YYYY-MM-DD");
        }

        if (value === null || value === "") {
          info.data_fine = null;
        }
      },
    },

    fatture_ordinate: function () {
      const fatture = this.data.item.fatture?.dettagli || [];
      // Prima quelle da pagare, poi le pagate; dentro ogni gruppo resta l'ordine del backend
      return [
        ...fatture.filter((el) => this.isFatturaDaPagare(el)),
        ...fatture.filter((el) => !this.isFatturaDaPagare(el)),
      ];
    },
    hasWizardCaricamentiAccess() {
      try {
        const encodedUser =
          this.store?.state?.auth?.user || localStorage.getItem("user");

        if (!encodedUser) {
          return false;
        }

        const decodedUser = JSON.parse(atob(encodedUser));
        const profile = decodedUser?.user?.[0]?.profile;

        if (!profile) {
          return false;
        }

        return profile.name === "all" || profile.all === 1;
      } catch (error) {
        console.error("Errore nel controllo del profilo utente:", error);
        return false;
      }
    },
  },

  setup() {
  const router = useRouter();
  const store = useStore();

  return {
    router,
    store,
  };
}
};
</script>

<style>
.mensilita-edit-hint {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0 0 0.75rem;
  color: #475569;
  font-size: 0.85rem;
}
.mensilita-edit-hint .pi-pencil {
  color: #1e3a8a;
  font-size: 0.8rem;
}
.editable-date-cell {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.15rem 0.35rem 0.15rem 0;
  border-bottom: 1px dashed #64748b;
  color: #1e3a8a;
  cursor: pointer;
}
.editable-date-cell .pi-pencil {
  font-size: 0.72rem;
  opacity: 0.75;
}
.editable-date-cell:hover {
  border-bottom-color: #1e3a8a;
}
.editable-date-cell:hover .pi-pencil {
  opacity: 1;
}
.p-datatable .p-datatable-tbody > tr.fattura-da-pagare {
  background-color: #fef2f2;
}

.p-datatable .p-datatable-tbody > tr.fattura-da-pagare > td:first-child {
  border-left: 4px solid #ef4444;
}

.preview-fattura-accordion {
  margin-bottom: 1rem;
}

.preview-fattura-accordion__title {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
}

.preview-fattura-accordion__icon {
  color: #b45309;
}

.preview-fattura-accordion .p-accordion-header-link {
  background: linear-gradient(90deg, #fff7ed 0%, #ffedd5 100%) !important;
  border: 1px solid #fdba74 !important;
  border-left: 4px solid #f97316 !important;
  color: #9a3412 !important;
}

.preview-fattura-accordion .p-accordion-header-link:hover {
  background: linear-gradient(90deg, #ffedd5 0%, #fed7aa 100%) !important;
}

.preview-fattura-accordion .p-accordion-tab-active .p-accordion-header-link {
  background: linear-gradient(90deg, #ffedd5 0%, #fdba74 100%) !important;
}

.preview-fattura-accordion .p-accordion-content {
  border: 1px solid #fdba74 !important;
  border-top: none !important;
  background-color: #fffaf5 !important;
}

.storico-autolettura-content {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}

.storico-autolettura-state {
  align-items: center;
  color: var(--text-color-secondary);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  justify-content: center;
  min-height: 140px;
  padding: 1.5rem 1rem;
  text-align: center;
}

.storico-autolettura-state p {
  margin: 0;
}

.storico-autolettura-state--empty i {
  font-size: 1.75rem;
  opacity: 0.45;
}

.storico-autolettura-alert {
  align-items: flex-start;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  color: #b91c1c;
  display: flex;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
}

.storico-autolettura-alert i {
  font-size: 1.1rem;
  margin-top: 0.1rem;
}

.storico-section {
  background: var(--surface-ground);
  border: 1px solid var(--surface-border);
  border-radius: 10px;
  overflow: hidden;
}

.storico-section-title {
  align-items: center;
  background: var(--surface-card);
  border-bottom: 1px solid var(--surface-border);
  color: var(--text-color);
  display: flex;
  font-size: 0.82rem;
  font-weight: 700;
  gap: 0.5rem;
  letter-spacing: 0.04em;
  margin: 0;
  padding: 0.7rem 0.9rem;
  text-transform: uppercase;
}

.storico-section-title i {
  color: var(--primary-color);
}

.storico-values-grid {
  display: grid;
  gap: 0.65rem;
  grid-template-columns: repeat(auto-fill, minmax(88px, 1fr));
  padding: 0.85rem;
}

.storico-value-card {
  background: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-height: 68px;
  padding: 0.55rem 0.6rem;
}

.storico-value-label {
  color: var(--text-color-secondary);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.storico-value-number {
  color: var(--text-color);
  font-size: 1rem;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

.storico-info-list {
  display: flex;
  flex-direction: column;
}

.storico-info-row {
  align-items: center;
  border-bottom: 1px solid var(--surface-border);
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 0.7rem 0.9rem;
}

.storico-info-row:last-child {
  border-bottom: none;
}

.storico-info-label {
  color: var(--text-color-secondary);
  font-size: 0.85rem;
  font-weight: 600;
}

.storico-info-value {
  color: var(--text-color);
  font-size: 0.92rem;
  font-weight: 600;
  text-align: right;
}

.storico-info-value--external {
  color: #0d9488;
}

.storico-info-value--internal {
  color: #2563eb;
}

.storico-info-value--system {
  color: var(--text-color-secondary);
  font-style: italic;
}

.text-muted {
  color: var(--text-color-secondary);
}

.wizard-log-json {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 0.85rem;
  line-height: 1.4;
}
</style>